// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* <div className="d-flex justify-content-between mb-4">
<div>
  <label>Playback speed control</label>
</div>
<div>
  <label className="switch">
    <input
      type="checkbox"
      name="enable_speed_control"
      onChange={handleToggle}
      checked={playerData?.enable_speed_control === 1 || playerData?.enable_speed_control === "1"}
    />
    <span className="slider round"></span>
  </label>
</div>
</div>
<div className="mb-4">
<div className="mt-2">
  <div className="text-dark">
    <Select
      options={optionstranscoding_resolution}
      isMulti
      className=""
      placeholder="Select Playback Speed"
      onChange={handleSelectChangeresolution}
      value={selectedValuesresolution}
      isDisabled={!(playerData?.enable_speed_control === 1 || playerData?.enable_speed_control === "1")}
    />
  </div>
</div>
</div>



var dataresolution = response?.data?.video_player_settings[0]?.show_speed_control;
        const formattedOptionsresolution = dataresolution?.map((item) => ({
          value: item?.key || JSON.parse(item?.key),
          label: item?.value || JSON.parse(item?.value),
        }));
        setSelectedValuesresolution(formattedOptionsresolution);
        setOptionstranscoding_resolution(formattedOptionsresolution);
        const datatranscoding_resolution = response?.data?.speed_control;
        const formattedOptionstranscoding_resolution = datatranscoding_resolution?.map((item) => ({
          value: item?.key,
          label: item?.value,
        }));
        console.log("formattedOptionstranscoding_resolution", formattedOptionstranscoding_resolution);
        setOptionstranscoding_resolution(formattedOptionstranscoding_resolution);
      })



      const [optionstranscoding_resolution, setOptionstranscoding_resolution] = useState([]);
      const [selectedValuesresolution, setSelectedValuesresolution] = useState([]);
      const handleSelectChangeresolution = (selectedOptionsresolution) => {
        setSelectedValuesresolution(selectedOptionsresolution);
      }; */
.custom-nav-tabs {
    border-bottom: 2px solid rgba(255, 255, 255, 0.1) !important;
    gap: 10px;
    margin-bottom: 25px;
    border: none;
}

.custom-nav-tabs .nav-item .nav-link {
    color: rgba(255, 255, 255, 0.6) !important;
    background: transparent !important;
    border: none !important;
    padding: 12px 25px !important;
    font-weight: 600 !important;
    font-size: 15px !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
    position: relative;
    border-radius: 0 !important;
}

.custom-nav-tabs .nav-item .nav-link:hover {
    color: #fff !important;
}

.custom-nav-tabs .nav-item .nav-link.active {
    color: #fff !important;
}

.custom-nav-tabs .nav-item .nav-link.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 10%;
    width: 80%;
    height: 3px;
    background: #ffc107; /* Using a yellow/gold accent commonly seen in premium VOD apps */
    border-radius: 10px 10px 0 0;
    box-shadow: 0 -2px 10px rgba(255, 193, 7, 0.4);
}

.vertical-settings-wrapper {
    animation: fadeIn 0.4s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

.tab-container {
    background: rgba(255, 255, 255, 0.03);
    padding: 10px 20px 0 20px;
    border-radius: 12px 12px 0 0;
    margin-top: 20px;
}

.iq-card {
  padding: 15px;
}

.home_mobile .nav-tabs {
  border-bottom: 2px solid rgba(255, 255, 255, 0.1);
  gap: 10px;
  padding-bottom: 5px;
}

.home_mobile .nav-link {
  background: rgba(255, 255, 255, 0.05);
  font-size: 14px;
  font-weight: 500;
  color: #6c757d;
  border: 1px solid transparent;
  padding: 12px 25px;
  border-radius: 8px 8px 0 0;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.home_mobile .nav-link h6 {
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 600;
}

.home_mobile .nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #006aff;
  border-color: rgba(255, 255, 255, 0.1);
}

.home_mobile .nav-link.active {
  background: rgba(0, 106, 255, 0.1);
  color: #006aff !important;
  border-bottom: 2px solid #006aff !important;
  font-weight: 700;
  border-radius: 8px 8px 0 0;
  padding: 12px 30px;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Player_UI/Player.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;UAwDU;AACV;IACI,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,0CAA0C;IAC1C,kCAAkC;IAClC,uBAAuB;IACvB,6BAA6B;IAC7B,2BAA2B;IAC3B,0BAA0B;IAC1B,4DAA4D;IAC5D,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB,EAAE,iEAAiE;IACtF,4BAA4B;IAC5B,8CAA8C;AAClD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,kBAAkB;EAClB,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,2CAA2C;EAC3C,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB","sourcesContent":["/* <div className=\"d-flex justify-content-between mb-4\">\n<div>\n  <label>Playback speed control</label>\n</div>\n<div>\n  <label className=\"switch\">\n    <input\n      type=\"checkbox\"\n      name=\"enable_speed_control\"\n      onChange={handleToggle}\n      checked={playerData?.enable_speed_control === 1 || playerData?.enable_speed_control === \"1\"}\n    />\n    <span className=\"slider round\"></span>\n  </label>\n</div>\n</div>\n<div className=\"mb-4\">\n<div className=\"mt-2\">\n  <div className=\"text-dark\">\n    <Select\n      options={optionstranscoding_resolution}\n      isMulti\n      className=\"\"\n      placeholder=\"Select Playback Speed\"\n      onChange={handleSelectChangeresolution}\n      value={selectedValuesresolution}\n      isDisabled={!(playerData?.enable_speed_control === 1 || playerData?.enable_speed_control === \"1\")}\n    />\n  </div>\n</div>\n</div>\n\n\n\nvar dataresolution = response?.data?.video_player_settings[0]?.show_speed_control;\n        const formattedOptionsresolution = dataresolution?.map((item) => ({\n          value: item?.key || JSON.parse(item?.key),\n          label: item?.value || JSON.parse(item?.value),\n        }));\n        setSelectedValuesresolution(formattedOptionsresolution);\n        setOptionstranscoding_resolution(formattedOptionsresolution);\n        const datatranscoding_resolution = response?.data?.speed_control;\n        const formattedOptionstranscoding_resolution = datatranscoding_resolution?.map((item) => ({\n          value: item?.key,\n          label: item?.value,\n        }));\n        console.log(\"formattedOptionstranscoding_resolution\", formattedOptionstranscoding_resolution);\n        setOptionstranscoding_resolution(formattedOptionstranscoding_resolution);\n      })\n\n\n\n      const [optionstranscoding_resolution, setOptionstranscoding_resolution] = useState([]);\n      const [selectedValuesresolution, setSelectedValuesresolution] = useState([]);\n      const handleSelectChangeresolution = (selectedOptionsresolution) => {\n        setSelectedValuesresolution(selectedOptionsresolution);\n      }; */\n.custom-nav-tabs {\n    border-bottom: 2px solid rgba(255, 255, 255, 0.1) !important;\n    gap: 10px;\n    margin-bottom: 25px;\n    border: none;\n}\n\n.custom-nav-tabs .nav-item .nav-link {\n    color: rgba(255, 255, 255, 0.6) !important;\n    background: transparent !important;\n    border: none !important;\n    padding: 12px 25px !important;\n    font-weight: 600 !important;\n    font-size: 15px !important;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n    position: relative;\n    border-radius: 0 !important;\n}\n\n.custom-nav-tabs .nav-item .nav-link:hover {\n    color: #fff !important;\n}\n\n.custom-nav-tabs .nav-item .nav-link.active {\n    color: #fff !important;\n}\n\n.custom-nav-tabs .nav-item .nav-link.active::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 10%;\n    width: 80%;\n    height: 3px;\n    background: #ffc107; /* Using a yellow/gold accent commonly seen in premium VOD apps */\n    border-radius: 10px 10px 0 0;\n    box-shadow: 0 -2px 10px rgba(255, 193, 7, 0.4);\n}\n\n.vertical-settings-wrapper {\n    animation: fadeIn 0.4s ease-out;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.tab-container {\n    background: rgba(255, 255, 255, 0.03);\n    padding: 10px 20px 0 20px;\n    border-radius: 12px 12px 0 0;\n    margin-top: 20px;\n}\n\n.iq-card {\n  padding: 15px;\n}\n\n.home_mobile .nav-tabs {\n  border-bottom: 2px solid rgba(255, 255, 255, 0.1);\n  gap: 10px;\n  padding-bottom: 5px;\n}\n\n.home_mobile .nav-link {\n  background: rgba(255, 255, 255, 0.05);\n  font-size: 14px;\n  font-weight: 500;\n  color: #6c757d;\n  border: 1px solid transparent;\n  padding: 12px 25px;\n  border-radius: 8px 8px 0 0;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.home_mobile .nav-link h6 {\n  margin-bottom: 0;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.home_mobile .nav-link:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #006aff;\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.home_mobile .nav-link.active {\n  background: rgba(0, 106, 255, 0.1);\n  color: #006aff !important;\n  border-bottom: 2px solid #006aff !important;\n  font-weight: 700;\n  border-radius: 8px 8px 0 0;\n  padding: 12px 30px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
